module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>clock</title><path d=\"M25,27.82,37.18,21.9a1.41,1.41,0,1,0-1.23-2.53L25.56,24V11.77a1.46,1.46,0,0,0-2.91,0l0,14.71A1.54,1.54,0,0,0,25,27.82Z\"></path><path d=\"M25,1A24,24,0,1,0,49,25,24,24,0,0,0,25,1Zm0,45.26A21.26,21.26,0,1,1,46.27,25,21.26,21.26,0,0,1,25,46.26Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/clock-01.svg
// module id = 542
// module chunks = 1